import React from 'react';
import '../lib/dotlottieWasm';
import { DotLottieReact as DotLottieReactRaw, DotLottieReactProps } from '@lottiefiles/dotlottie-react';
import loadingLottie from '../assets/sally-tidal.lottie';

const DotLottieReact = DotLottieReactRaw as unknown as React.FC<DotLottieReactProps>;

interface LoadingAnimationProps {
  size?: number;
  /** Playback rate — >1 is faster. */
  speed?: number;
  className?: string;
}

const LoadingAnimation: React.FC<LoadingAnimationProps> = ({ size = 150, speed = 1.4, className }) => {
  return (
    <div className={className} style={{ width: size, height: size }}>
      <DotLottieReact src={loadingLottie} loop autoplay speed={speed} />
    </div>
  );
};

export default LoadingAnimation;
